import { createSelector } from '@ngrx/store';
import { getOnboardingPageState } from '../onboarding.selectors';

// ------------------- GLOBAL STATE ----------------
export const getBusinessAndGmbStatusState = createSelector(
  getOnboardingPageState,
  (state) => state.businessDataAndGmbStatusState
);

// ------------------- BUSINESS STATE SELECTORS ----------------
export const getBusinessState = createSelector(
  getBusinessAndGmbStatusState,
  (businessAndGmbState) => businessAndGmbState.businessState
);
export const getBusinessStateData = createSelector(
  getBusinessState,
  (businessState) => businessState.data
);
export const getBusinessStateIsLoading = createSelector(
  getBusinessState,
  (businessState) => businessState.isLoading
);
export const getBusinessStateSuccess = createSelector(
  getBusinessState,
  (businessState) => businessState.success
);
export const getBusinessStateError = createSelector(
  getBusinessState,
  (businessState) => businessState.error
);
export const getBusinessHasBeenFetched = createSelector(
  getBusinessState,
  (businessState) => businessState.fetched || false
);

// ------------------- GMB STATE SELECTORS ----------------
export const getGmbStatusState = createSelector(
  getBusinessAndGmbStatusState,
  (businessAndGmbState) => businessAndGmbState.gmbStatusState
);
export const getGmbStatusStateData = createSelector(
  getGmbStatusState,
  (gmbStatusState) => gmbStatusState.data
);
export const getGmbStatusStateIsLoading = createSelector(
  getGmbStatusState,
  (gmbStatusState) => gmbStatusState.isLoading
);
export const getGmbStatusStateSuccess = createSelector(
  getGmbStatusState,
  (gmbStatusState) => gmbStatusState.success
);
export const getGmbStatusStateError = createSelector(
  getGmbStatusState,
  (gmbStatusState) => gmbStatusState.error
);
export const gmbStatusHasBeenFetched = createSelector(
  getGmbStatusState,
  (gmbStatusState) => gmbStatusState.fetched || false
);

// ------------------- MODULES-DATA STATE SELECTORS ----------------
export const getModulesDataState = createSelector(
  getOnboardingPageState,
  (onboardingState) => onboardingState.modulesDataState
);

export const getBusinessAdditionalInfoState = createSelector(
  getModulesDataState,
  (modulesState) => modulesState.businessAdditionalInfo
);
